import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: ['chartData'],
    data() {
        return {
            options: {
                responsive: false,
                maintainAspectRatio: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            display: true //this will remove only the label
                        }
                    }]
                },
                // animation: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}
